const __DEV__ = false;

var data = { shadows:{ values:{ "1":"0px 2px 8px rgba(0, 0, 0, 0.1)" } } };

var shadows = data;

export { shadows as default };
//# sourceMappingURL=shadows.yaml.js.map
